"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

var _Spinner = require("./Spinner.shared");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// @ts-ignore
var spin = (0, _styledComponents.keyframes)(["100%{transform:rotate(360deg)}"]);
/** Generic Spinner component */

var Spinner = _styledComponents.default.div.withConfig({
  displayName: "Spinner",
  componentId: "sc-1t000ax-0"
})(["animation:", " 1s infinite linear;position:absolute;", ";"], spin, function (props) {
  var _getSize = (0, _Spinner.getSize)(props),
      width = _getSize.width,
      height = _getSize.height;

  return "\n      background: ".concat((0, _helpers.color)(props.color), ";\n      width: ").concat(width, "px;\n      height: ").concat(height, "px;\n      top: calc(50% - ").concat(height, "px / 2);\n      left: calc(50% - ").concat(width, "px / 2);\n    ");
});

exports.Spinner = Spinner;
Spinner.defaultProps = {
  width: 25,
  height: 6,
  color: "black100"
};
Spinner.displayName = "Spinner";
//# sourceMappingURL=Spinner.js.map